import { axiosRubyClient } from '@/util/axios/axiosClient';

export interface OnboardingStep {
  id: string;
  title: string;
  status: 'pending' | 'in_progress' | 'completed' | 'under_review' | 'rejected';
  disabled: boolean;
}

export interface GetOnboardingStepsResponse {
  success: boolean;
  steps: OnboardingStep[];
  message?: string;
}

export interface UpdateStepRequest {
  id: string;
  status: 'pending' | 'in_progress' | 'completed' | 'under_review' | 'rejected';
}

export interface UpdateStepsResponse {
  success: boolean;
  steps: OnboardingStep[];
  message?: string;
}

export class OnboardingStepsAPI {
  /**
   * Get onboarding steps for a worker
   */
  static async getWorkerOnboardingSteps(
    workerId: number,
  ): Promise<GetOnboardingStepsResponse> {
    const response = await axiosRubyClient.get(
      `/api/admin/onboarding_steps?worker_id=${workerId}`,
    );
    return response.data;
  }

  /**
   * Update worker onboarding step status
   */
  static async updateWorkerOnboardingSteps(
    workerId: number,
    stepId: string,
    status: string,
  ): Promise<UpdateStepsResponse> {
    const response = await axiosRubyClient.patch(
      `/api/admin/onboarding_steps`,
      {
        worker_id: workerId,
        step_id: stepId,
        status,
      },
    );
    return response.data;
  }
}
